import * as React from "react";
import { Checkbox, Radio } from "../../externals";
import { Everyday } from "../../../entities";
import { StartsAtSelector } from "../customInputs/StartsAtSelector";
import { defWeeklyCronFirst, defWeeklyCronSecond, defWeeklyCronThird, } from "../defaultCronOptions";
export class WeeklyPanel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onChangeWeekly = (value) => {
            let days = this.state.selectedDays;
            let cron = Object.assign({}, this.props.cron);
            if (!days.includes(value.substring(0, 3))) {
                days.push(value.substring(0, 3));
            }
            else {
                const index = days.indexOf(value.substring(0, 3));
                days.splice(index, 1);
            }
            cron.weekday = days.join();
            this.props.onChange(cron);
        };
        this.state = {
            selectedDays: [],
            selectedOption: 0,
        };
    }
    render() {
        return (React.createElement("div", { id: "weeklyPanel" },
            React.createElement("div", { id: "firstOption" },
                React.createElement(Radio, { label: "Everyday", checked: this.state.selectedOption === 0, onChange: () => {
                        this.setState({ selectedOption: 0, selectedDays: [] });
                        this.props.onChange(Object.assign(Object.assign({}, defWeeklyCronFirst), { minutes: this.props.startsAt[1], hours: this.props.startsAt[0] }));
                    }, className: "option-item" })),
            React.createElement("div", { id: "secondOption" },
                React.createElement(Radio, { label: "Every weekday", checked: this.state.selectedOption === 1, onChange: () => {
                        this.setState({ selectedOption: 1, selectedDays: [] });
                        this.props.onChange(Object.assign(Object.assign({}, defWeeklyCronSecond), { minutes: this.props.startsAt[1], hours: this.props.startsAt[0] }));
                    }, style: { paddingTop: "8px" }, className: "option-item" })),
            React.createElement("div", { id: "thirdOption" },
                React.createElement(Radio, { label: "Custom day selector", checked: this.state.selectedOption === 2, onChange: () => {
                        this.setState({ selectedOption: 2, selectedDays: [] });
                        this.props.onChange(Object.assign(Object.assign({}, defWeeklyCronThird), { minutes: this.props.startsAt[1], hours: this.props.startsAt[0] }));
                    }, style: { paddingTop: "8px" }, className: "option-item" }),
                React.createElement("div", { id: "daysOptions", style: { marginBottom: "8px" } }, Object.keys(Everyday).map((value) => (React.createElement(Checkbox, { disabled: this.state.selectedOption !== 2, onChange: () => this.onChangeWeekly(value), key: value.substring(0, 3), label: Everyday[value], checked: this.state.selectedDays.includes(value.substring(0, 3)) }))))),
            React.createElement(StartsAtSelector, { startsAtChange: (value) => this.props.startsAtChange(value), startsAt: this.props.startsAt })));
    }
}
//# sourceMappingURL=WeeklyPanel.js.map